import type { GQLSlice } from './generated/slices'
import type { SliceLayout } from '@core/types/generated'

export type Slice = {
  layout: SliceLayout
  id?: string
  class?: string
  type: GQLSlice['_type']
  content: GQLSlice | GQLSlice[] | null
}

export enum ContainerType {
  ASIDE = 'aside',
  BOX = 'box',
  FREE = 'free',
}

export type Container = {
  type: ContainerType
  slices: Slice[]
}

export enum SectionType {
  VERTICAL_BOX = 'verticalBox',
  VERTICAL_FREE = 'verticalFree',
  FLUID = 'fluid',
  SIDEBAR = 'sidebar',
}

export type Section = {
  id?: number
  type: SectionType
  items: Container[]
}
